import React from 'react';
import Modal from './Modal';

function ConfirmModal({
  open,
  title,
  message,
  confirmLabel = 'Confirmar',
  confirmingLabel = 'Removendo...',
  cancelLabel = 'Cancelar',
  onConfirm,
  onCancel,
  isConfirming = false,
}) {
  return (
    <Modal open={open} onClose={onCancel} title={title} disableClose={isConfirming}>
      <p className="text-sm text-content-muted mt-2">{message}</p>

      <div className="flex flex-col sm:flex-row gap-3 mt-6">
        <button
          type="button"
          onClick={onCancel}
          disabled={isConfirming}
          className="btn-secondary flex-1 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={isConfirming}
          className="inline-flex flex-1 items-center justify-center gap-2 px-6 py-3 bg-red-600 text-white font-semibold rounded-xl hover:bg-red-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isConfirming ? confirmingLabel : confirmLabel}
        </button>
      </div>
    </Modal>
  );
}

export default ConfirmModal;
